// AUTO-GENERATED from @tsEnum enums in types.graphql — do not edit manually.
// Re-run `yarn codegen` to regenerate.

export enum ActionTriggerDataType {
  A2B_FULFILLMENT_WEBHOOK = 'A2bFulfillmentWebhook',
  ADD_ROW = 'AddRow',
  AIRTABLE_WEBHOOK = 'AirtableWebhook',
  AMAZON_SELLER_WEBHOOK = 'AmazonSellerWebhook',
  BILL_WEBHOOK = 'BillWebhook',
  CARTONCLOUD_WEBHOOK = 'CartonCloudWebhook',
  DELETE_ROW = 'DeleteRow',
  DOSS_BANKING_WEBHOOK = 'DossBankingWebhook',
  DOSS_BILL_PAY_WEBHOOK = 'DossBillPayWebhook',
  EASYPOST_WEBHOOK = 'EasyPostWebhook',
  EXTENSIV_WEBHOOK = 'ExtensivWebhook',
  FENO_WEBHOOK = 'FenoWebhook',
  FIRSTBASE_WEBHOOK = 'FirstbaseWebhook',
  FLEXPORT_WEBHOOK = 'FlexportWebhook',
  FORM = 'Form',
  FORM_V2 = 'FormV2',
  FORTY_SEAS_WEBHOOK = 'FortySeasWebhook',
  GMAIL_WEBHOOK = 'GmailWebhook',
  GNOSIS_WEBHOOK = 'GnosisWebhook',
  GOFREIGHT_WEBHOOK = 'GofreightWebhook',
  HUBSPOT_WEBHOOK = 'HubSpotWebhook',
  INGRAM_MICRO_WEBHOOK = 'IngramMicroWebhook',
  JAY_GROUP_WEBHOOK = 'JayGroupWebhook',
  JAZZ_WEBHOOK = 'JazzWebhook',
  LAZADA_WEBHOOK = 'LazadaWebhook',
  LOCAD_WEBHOOK = 'LocadWebhook',
  LOGIWA_WEBHOOK = 'LogiwaWebhook',
  LOOP_RETURNS_WEBHOOK = 'LoopReturnsWebhook',
  MAYA_WEBHOOK = 'MayaWebhook',
  MINTSOFT_WEBHOOK = 'MintsoftWebhook',
  MISFITS_MARKET_WEBHOOK = 'MisfitsMarketWebhook',
  NAVISPHERE_WEBHOOK = 'NavisphereWebhook',
  OUTLOOK_WEBHOOK = 'OutlookWebhook',
  QUICKBOOKS_WEBHOOK = 'QuickbooksWebhook',
  RILLET_WEBHOOK = 'RilletWebhook',
  ROUTABLE_WEBHOOK = 'RoutableWebhook',
  SALSIFY_WEBHOOK = 'SalsifyWebhook',
  SHIPBOB_WEBHOOK = 'ShipBobWebhook',
  SHIPHERO_WEBHOOK = 'ShipHeroWebhook',
  SHIPMONK_WEBHOOK = 'ShipMonkWebhook',
  SHIPWIRE_WEBHOOK = 'ShipwireWebhook',
  SHOPEE_WEBHOOK = 'ShopeeWebhook',
  SHOPIFY_WEBHOOK = 'ShopifyWebhook',
  SILQ_WEBHOOK = 'SilqWebhook',
  STORD_WEBHOOK = 'StordWebhook',
  STRIPE_WEBHOOK = 'StripeWebhook',
  THINK_LOGISTICS_WEBHOOK = 'ThinkLogisticsWebhook',
  TIKTOK_SHOP_WEBHOOK = 'TiktokShopWebhook',
  UPDATE_CELL = 'UpdateCell',
  UPDATE_ROW = 'UpdateRow',
  USA_SUPPLY_PORTAL_WEBHOOK = 'USASupplyPortalWebhook',
  WALMART_WEBHOOK = 'WalmartWebhook',
  WOO_COMMERCE_WEBHOOK = 'WooCommerceWebhook',
}
